import { memo, useState } from 'react';
import { ChevronRight, ChevronDown } from 'lucide-react';
import { Badge } from '@/components/ui';
import type { SourceGroupItem } from './useEventGrouping';
import EventCard from './EventCard';

function formatTimestamp(ts: string): string {
  const d = new Date(ts);
  return d.toLocaleTimeString(undefined, {
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
  });
}

function SourceGroupCardInner({ group }: { group: SourceGroupItem }) {
  const [expanded, setExpanded] = useState(false);

  return (
    <div data-testid="source-group-card">
      <button
        type="button"
        onClick={() => setExpanded((v) => !v)}
        className="w-full rounded-lg border border-l-2 border-l-accent-subagent-border/40 bg-card p-3 flex items-center gap-3 hover:bg-accent/50 transition-colors text-left"
      >
        {expanded ? (
          <ChevronDown className="h-4 w-4 shrink-0 text-muted-foreground" />
        ) : (
          <ChevronRight className="h-4 w-4 shrink-0 text-muted-foreground" />
        )}
        <span className="font-mono text-xs text-muted-foreground whitespace-nowrap">
          {formatTimestamp(group.latestTimestamp)}
        </span>
        <Badge variant="info">{group.source}</Badge>
        <span className="text-xs text-muted-foreground ml-auto whitespace-nowrap">
          {group.events.length} event{group.events.length !== 1 ? 's' : ''}
        </span>
      </button>

      {expanded && (
        <div className="ml-6 mt-1 pl-3 space-y-2">
          {group.events.map((event) => (
            <EventCard key={event.eventId} event={event} />
          ))}
        </div>
      )}
    </div>
  );
}

const SourceGroupCard = memo(SourceGroupCardInner);
export default SourceGroupCard;
